import React, { useState, useEffect }  from "react";
import {Link } from "react-scroll";
import Carousel from "./SpinningPictures";
import Navbar from "./Navbar";
import outsideView4 from "../../images/outsideView4.jpg";
import logo from "../../images/logo_villaresidence_transparent.png";
import "./AnimatedElements.css";

export default function HomeAnimation() {

    //const[className, setClassName] = useState(window.innerWidth >= 850 ? "First" : "");
    //const[showCarousel, setShowCaroulsel] = useState(window.innerWidth >= 850 ? "First" : "");

    const[className, setClassName] = useState("");
    const[showCarousel, setShowCaroulsel] = useState("");
    const [scrollOffsetCarousel, setscrollOffsetCarousel] = useState(0);

   /* useEffect(() => {
        scrollOffsetPicturesContainer();
        setTimeout(() => {setClassName("")}, 5000);
        setTimeout(() => {setShowCaroulsel("")}, 7000);
    }, []);
 */
    const scrollOffsetPicturesContainer = () => {
        const divHeight = document.getElementById("picturesContainer").getBoundingClientRect().height;
       // const carouselscrollOffset = window.innerWidth > 850 ? divHeight * 0.3 : 0;
        setscrollOffsetCarousel(divHeight * 0.3);
      };

    return (
        <div className="imageContainer" id="homeContainer">
            <div className={"navbarAntua"}><Navbar/></div>
            <div><img className={"logo"} src={logo} alt="logo" /></div>
            <div><p className={"slogan"}>Um novo conceito de vida</p></div>
            <Link
                to="picturesContainer"
                spy={true}
                smooth={true}
                duration={750}
                offset={scrollOffsetCarousel}
              >
               <div className={"slideshowContainer" + showCarousel}> <Carousel /> </div> 
              </Link>           
        </div>
    )
}